import { all, call, put, takeLatest } from 'redux-saga/effects';
import {
  getRequestLandlord,
  getRequestVP,
  sendPropertyRequest,
  getRequestBuilding,
  getRequestUserProperty,
} from './APIs/delegation';
import { getApiErrorMessage } from 'utils/apiError';
import { successNotif, failedNotif } from '../actions/notifActions';
import { setLoading } from '../actions/authActions';
import {
  setRequestLandlordAction,
  setRequestVPAction,
  setRequestBuildingAction,
  setRequestUserPropertyAction,
  getRequestLandlordAction,
  getRequestVPAction,
} from '../actions/delegationActions';
import types from '../constants/delegationConstants';

function* getRequestLandlordSaga() {
  try {
    const data = yield getRequestLandlord();
    yield put(setRequestLandlordAction(data));
  } catch (error) {
    yield put(failedNotif(getApiErrorMessage(error, 'Failed to load companies.')));
  }
}

function* sendPropertyRequestSaga({ payload }) {
  try {
    yield put(setLoading(true));
    yield put(successNotif(null));
    yield put(failedNotif(null));
    const response = yield sendPropertyRequest(payload);
    yield put(successNotif(response.message || 'Request sent successfully.'));
    yield put(getRequestLandlordAction());
    yield put(getRequestVPAction());
  } catch (error) {
    yield put(failedNotif(getApiErrorMessage(error, 'Failed to send request. Please try again.')));
  } finally {
    yield put(setLoading(false));
  }
}

function* getRequestVPSaga() {
  try {
    const response = yield getRequestVP();
    yield put(setRequestVPAction(response));
  } catch (error) {
    yield put(failedNotif(getApiErrorMessage(error, 'Failed to load full portfolio users.')));
  }
}

function* getRequestBuildingSaga() {
  try {
    const data = yield getRequestBuilding();
    yield put(setRequestBuildingAction(data));
  } catch (error) {
    yield put(failedNotif(getApiErrorMessage(error, 'Failed to load request buildings.')));
  }
}

function* getRequestUserPropertySaga({ payload }) {
  try {
    const data = yield getRequestUserProperty(payload);
    yield put(setRequestUserPropertyAction(data));
  } catch (error) {
    yield put(failedNotif(getApiErrorMessage(error, 'Failed to load properties.')));
  }
}

function* onGetRequestLandlord() {
  yield takeLatest(types.GET_REQUEST_LANDLORD, getRequestLandlordSaga);
}

function* onSendPropertyRequest() {
  yield takeLatest(types.SEND_PROPERTY_REQUEST, sendPropertyRequestSaga);
}

function* onGetRequestVP() {
  yield takeLatest(types.GET_REQUEST_VP, getRequestVPSaga);
}

function* onGetRequestBuilding() {
  yield takeLatest(types.GET_REQUEST_BUILDING, getRequestBuildingSaga);
}

function* onGetRequestUserProperty() {
  yield takeLatest(types.GET_RQUEST_USER_PROPERTY, getRequestUserPropertySaga);
}

export default function* delegationSaga() {
  yield all([
    call(onGetRequestLandlord),
    call(onSendPropertyRequest),
    call(onGetRequestVP),
    call(onGetRequestBuilding),
    call(onGetRequestUserProperty),
  ]);
}
